// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3FPld","vLegacy":"SelectSecondary_vLegacy__LcYnq","error":"SelectSecondary_error__2JUhF","disabled":"SelectSecondary_disabled__7O1PS"};